import { useState } from "react";
import { PACKAGES } from "@/data/credits";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Coins, Loader2, Check } from "lucide-react";

export const CreditPackages = ({ compact = false }) => {
  const [loading, setLoading] = useState(null);

  const buy = async (lookup_key) => {
    setLoading(lookup_key);
    try {
      const { data } = await api.post("/payments/checkout", {
        lookup_key,
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error("No se pudo iniciar el pago");
      setLoading(null);
    }
  };

  return (
    <div className={`grid gap-4 ${compact ? "grid-cols-1 sm:grid-cols-3" : "grid-cols-1 md:grid-cols-3"}`} data-testid="credit-packages">
      {PACKAGES.map((p) => (
        <div
          key={p.lookup_key}
          data-testid={`package-${p.lookup_key}`}
          className={`relative border rounded-sm p-6 flex flex-col gap-4 bg-white transition-transform hover:-translate-y-0.5 ${
            p.popular ? "border-[#002FA7] shadow-[0_0_0_1px_#002FA7]" : "border-border"
          }`}
        >
          {p.popular && (
            <span className="absolute -top-2.5 left-6 bg-[#002FA7] text-white text-[10px] uppercase tracking-[0.2em] px-2 py-1 rounded-sm">
              {p.tag}
            </span>
          )}
          <div className="flex items-center gap-2 text-[#CA8A04]">
            <Coins className="w-5 h-5" />
            <span className="text-3xl font-display font-semibold tracking-tight text-foreground">{p.credits}</span>
            <span className="text-xs uppercase tracking-[0.2em] text-neutral-500 mt-2">créditos</span>
          </div>
          <div className="text-2xl font-display font-semibold tracking-tight">{p.price}</div>
          <ul className="text-sm text-neutral-500 flex flex-col gap-1.5">
            <li className="flex items-center gap-2"><Check className="w-3.5 h-3.5 text-[#002FA7]" /> {p.credits} operaciones base</li>
            <li className="flex items-center gap-2"><Check className="w-3.5 h-3.5 text-[#002FA7]" /> IA, sin fondo, 8K</li>
          </ul>
          <Button
            onClick={() => buy(p.lookup_key)}
            disabled={loading === p.lookup_key}
            className={`rounded-sm gap-2 mt-auto ${p.popular ? "bg-[#002FA7] hover:bg-[#00248a]" : "bg-neutral-900 hover:bg-neutral-800"}`}
            data-testid={`buy-${p.lookup_key}`}
          >
            {loading === p.lookup_key ? <Loader2 className="w-4 h-4 animate-spin" /> : <Coins className="w-4 h-4" />} Comprar
          </Button>
        </div>
      ))}
    </div>
  );
};
